import { render, staticRenderFns } from "./ListMessageTemplate.vue?vue&type=template&id=2704555e&scoped=true&"
import script from "./ListMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./ListMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ListMessageTemplate.vue?vue&type=style&index=0&id=2704555e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2704555e",
  null
  
)

export default component.exports